<app-nav-bar></app-nav-bar>

<div id="layoutSidenav">
  <app-side-bar></app-side-bar>

  <div id="layoutSidenav_content">
    <main>
      <div class="container-fluid">
        <h1 class="mt-4">Producción de reportes</h1>

        <div class="row" style="padding-top: 1%">
          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">1</h4>
              <p class="card-text">Selecciona el tipo de reporte a generar.</p>
              <select
                class="col-md-6 custom-select"
                [(ngModel)]="selectedReporte"
                #selectReporte
                (change)="resetTipoReporte(selectReporte.value)"
              >
                <option value="{{ rep }}" *ngFor="let rep of reportes">
                  {{ rep }}
                </option>
                >
              </select>
            </div>
            <br />
          </div>

          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">2</h4>
              <p class="card-text">Seleccione la fecha de inicio.</p>
              <input
                [(ngModel)]="fechaInicio"
                class="input-group"
                type="date"
                name="fechaInicio"
                id="fechaInicio"
              />
              <br />
              <br />
              <p class="card-text">Seleccione la fecha de fin.</p>
              <input
                [(ngModel)]="fechaFin"
                class="input-group"
                type="date"
                name="fechaFin"
                id="fechaFin"
              />
            </div>
            <br />
          </div>

          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">3</h4>
              <p class="card-text">Selecciona la extensión del reporte.</p>
              <select
                class="col-md-6 custom-select"
                [(ngModel)]="selectedExtensionReporte"
                #selectExtensionReporte
              >
                <option value="{{ trep }}" *ngFor="let trep of tipoReportes">
                  {{ trep }}
                </option>
                >
              </select>
            </div>
            <br />
          </div>

          <div class="card" style="width: 22rem">
            <div class="card-body">
              <h4 class="card-title">4</h4>
              <p class="card-text">Generar el reporte.</p>
              <button
                class="btn btn-warning text-white"
                type="button"
                (click)="downloadReporte()"
              >
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- </div> -->
      </div>
    </main>

    <footer class="py-4 bg-light mt-auto">
      <div class="container-fluid">
        <div class="d-flex align-items-center justify-content-between small">
          <div class="text-muted">Copyright &copy; Your Website 2020</div>
          <div>
            <a href="#">Privacy Policy</a>
            &middot;
            <a href="#">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
